import { ALPHA__Drawer as Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/ALPHA/Drawer";
import styles from "./PartnershipCardPointsSideDrawer.module.scss";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";

import OpenInNew24PxOutlinedIcon from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/OpenInNew24PxOutlined";

type PartnershipCardPointsSideDrawerProps = {
  handleClose: () => void;
  drawerIsOpen: boolean;
  points: number;
};

export const PartnershipCardPointsSideDrawer = ({
  handleClose,
  drawerIsOpen,
  points,
}: PartnershipCardPointsSideDrawerProps) => {
  return (
    <Drawer
      isOpen={drawerIsOpen}
      onClose={handleClose}
      header="Partnership Credit Card"
      footerClassName={styles.footerLayout}
      footerChildren={
        <>
          <UnderlinedButton
            className={styles.findOutMore}
            tag="a"
            target="_blank"
            data-testid="cardpoints:link:findoutmore"
            href="https://www.johnlewisfinance.com/credit-cards/partnership-card.html?sourcecode=3521466AAJLPDOM13500&utm_source=www.johnlewis.com&utm_medium=Banner&utm_campaign=PC0242&track=jli:acquisition%7CPC0242"
          >
            Find out more
          </UnderlinedButton>
          <OpenInNew24PxOutlinedIcon />
        </>
      }
      fullPage={true}
      className={styles.sideDrawer}
      isDrawerLeft={false}
      isHeaderFixed={true}
      isFooterFixed={true}
      isNarrow={false}
      rootId="page-root"
      contentClassName={styles.drawerContent}
      isLegacySPDPDrawer={true}
    >
      <h3>
        {`Earn ${points} points when you pay for this product with your Partnership Credit Card. 27.9% APR Representative (variable).`}
      </h3>
      <p>{`Credit subject to status. 18 years +. UK residents. T&Cs apply.`}</p>
      <h3>{`Earn points when you spend`}</h3>
      <p>
        {`With our Partnership Credit Card, you’ll earn points as you spend - whether that’s on a holiday, your weekly food shop or coffee with friends.`}
      </p>
      <h3>{`Earn`}</h3>
      <p>
        {`5 points for every £4 spent on eligible purchases at John Lewis and Waitrose and 1 point for every £4 spent everywhere else that accepts Mastercard. Reward terms apply.`}
      </p>
      <h3>{`Convert`}</h3>
      <p>
        {`For every 500 points you collect, you'll earn a £5 voucher. Vouchers are sent up to 3 three times a year, in February, June and October.`}
      </p>
      <h3>{`Enjoy`}</h3>
      <p>{`Turn your vouchers into shopping at John Lewis and Waitrose.`}</p>
      <h3>{`John Lewis plc is a credit broker and not a lender, introducing the Partnership Credit Card under exclusive arrangements with the lender NewDay Ltd.`}</h3>
      <p>
        {`John Lewis Finance is a trading name of John Lewis plc, registered in England with company number 233462, registered office: 171 Victoria Street, London SW1E 5NN. Authorised and regulated by the Financial Conduct Authority (FRN 724309).`}
      </p>
    </Drawer>
  );
};
